/**
 * Sunday header: the cart count follows the cart, the festival greeting shows only when it fits,
 * and the language choice is shared with the
 * order portal (localStorage['sunday-lang']) before the store switches language.
 * Phone bars (below 600 px): scrolling down slides the slim header up; scrolling up, the top of the page and its
 * end bring it back. The bottom bar stays put (26 Oct, AR: it flickered while sliding away and back).
 */
document.addEventListener('sunday:cart', (e) => {
  const a = document.querySelector('[data-cart-link]');
  if (!a || !e.detail?.cart) return;
  const n = e.detail.cart.item_count;
  let em = a.querySelector('[data-cart-count]');
  if (!n) {
    em?.remove();
  } else {
    if (!em) {
      em = document.createElement('em');
      em.dataset.cartCount = '';
      a.append(em);
    }
    em.textContent = n;
    em.classList.remove('sd-bump');
    void em.offsetWidth;
    em.classList.add('sd-bump');
  }
  if (a.dataset.tpl) a.setAttribute('aria-label', a.dataset.tpl.replace('[n]', n));
});

/* Language: Shopify's language form switches the page to that language's address (/hi/, /ta/ …).
   The language on screen is also kept in localStorage['sunday-lang'], a backup for the order portal.
   Delegated, because the menu sheet's pills are cloned in later. */
const keepLang = (v, chosen) => {
  try {
    if (v) localStorage.setItem('sunday-lang', v);
    /* a language picked by hand: the one-time offer under the header never shows again */
    if (chosen) localStorage.setItem('sunday-lang-offer', 'chosen');
  } catch (e) {
    /* storage blocked: the store still switches */
  }
};
keepLang(document.documentElement.lang);
/* 25 Oct (speed): the same page at the chosen language's address (/hi/products/…, query and #part kept), opened
   straight away. Shopify's language form made the buyer wait 1–1.5 s before the new page even started; the store
   serves a page in the language of its address, and checkout follows the cart page's address. */
const langUrl = (root) => {
  const cur = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  let rest = location.pathname;
  if (cur && (rest === cur || rest.startsWith(cur + '/'))) rest = rest.slice(cur.length) || '/';
  const r = (root || '/').replace(/\/$/, '');
  return (rest === '/' ? r || '/' : r + rest) + location.search + location.hash;
};
document.addEventListener('change', (e) => {
  const sel = e.target.closest && e.target.closest('select[data-sunday-lang]');
  if (!sel) return;
  keepLang(sel.value, true);
  const opt = sel.selectedOptions && sel.selectedOptions[0];
  if (opt && opt.dataset.root) location.assign(langUrl(opt.dataset.root));
  else sel.form.submit();
});
document.addEventListener('click', (e) => {
  const b = e.target.closest && e.target.closest('button[data-sunday-lang]');
  if (b) {
    keepLang(b.value, true);
    if (b.dataset.root) {
      e.preventDefault();
      if (!b.hasAttribute('aria-current')) location.assign(langUrl(b.dataset.root));
    }
  }
  /* the header's language pill (600–1099 px) closes on a tap outside it */
  document.querySelectorAll('details.sd-hlp[open]').forEach((d) => {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('details.sd-hlp[open]').forEach((d) => {
    d.removeAttribute('open');
    d.querySelector('summary').focus();
  });
});

/* Festival greeting beside the logo: shown only while it fits whole (never cut to "Happy Indep…").
   The inline check in sections/sunday-header.liquid did the first pass before the page was drawn;
   this keeps it right after fonts load and on resize. When it no longer fits, the page's own greeting
   slot (the home hero eyebrow) takes it, so it is still said once. */
/* Menu row from 720 to 1100 px: it scrolls sideways when it doesn't fit; fade the right edge while more is hidden. */
const dnav = document.querySelector('.sd-dnav');
if (dnav) {
  const more = () => dnav.classList.toggle('sd-navmore', dnav.scrollWidth - dnav.clientWidth - dnav.scrollLeft > 2);
  dnav.addEventListener('scroll', more, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(more).observe(dnav);
  addEventListener('load', more);
  more();
}

/* 30 Oct (AR go): hover panels under Mattresses and Accessories. Only with a real hover (no touch): the word opens its
   panel after 140 ms, the panel stays while the mouse is over it, closes 220 ms after leaving, on Esc, on scroll and when
   another word is hovered. Keyboard: Tab onto the word opens it (Enter still goes to the page). A click never opens; it
   goes to the page. From 1100 the panel starts under its word. */
if (dnav && matchMedia('(hover: hover) and (min-width: 720px)').matches) {
  const links = [...dnav.querySelectorAll('a[data-panel]')];
  const header = document.querySelector('[data-sunday-header]');
  let openT = 0, closeT = 0, cur = null;
  const panelOf = (a) => document.getElementById('sd-np-' + a.dataset.panel);
  const close = () => {
    clearTimeout(openT); clearTimeout(closeT);
    if (!cur) return;
    panelOf(cur).hidden = true;
    cur.setAttribute('aria-expanded', 'false');
    cur = null;
  };
  const show = (a) => {
    clearTimeout(closeT);
    if (cur === a) return;
    if (cur) { panelOf(cur).hidden = true; cur.setAttribute('aria-expanded', 'false'); }
    const p = panelOf(a);
    if (!p) return;
    /* the mattress cards live once in the phone menu's template; copied here on the first open */
    const slot = p.querySelector('[data-mx-cards-slot]');
    if (slot && !slot.children.length) {
      const t = document.querySelector('[data-menu-template]');
      const cards = t && t.content.querySelector('[data-sd-mxc]');
      if (cards) { slot.replaceWith(Object.assign(cards.cloneNode(true), { className: cards.className + ' sd-np-cards' })); document.dispatchEvent(new Event('sunday:menu-cards')); }
    }
    const hr = header.getBoundingClientRect();
    const ar = a.getBoundingClientRect();
    p.style.setProperty('--sd-np-left', Math.max(0, ar.left - hr.left - 20) + 'px');
    p.hidden = false;
    /* 31 Oct (AR go 4): never past the right edge (Accessories at 1100) */
    if (p.offsetWidth < hr.width) {
      const over = p.getBoundingClientRect().right - (hr.right - 16);
      if (over > 0) p.style.setProperty('--sd-np-left', Math.max(0, ar.left - hr.left - 20 - over) + 'px');
    }
    a.setAttribute('aria-expanded', 'true');
    cur = a;
  };
  const later = () => { clearTimeout(closeT); closeT = setTimeout(close, 220); };
  links.forEach((a) => {
    const p = panelOf(a);
    if (!p) return;
    a.addEventListener('mouseenter', () => { clearTimeout(openT); clearTimeout(closeT); openT = setTimeout(() => show(a), 140); });
    a.addEventListener('mouseleave', () => { clearTimeout(openT); later(); });
    a.addEventListener('focus', () => show(a));
    p.addEventListener('mouseenter', () => clearTimeout(closeT));
    p.addEventListener('mouseleave', later);
    p.addEventListener('focusout', (e) => { if (!p.contains(e.relatedTarget) && e.relatedTarget !== a) later(); });
  });
  dnav.querySelectorAll('a:not([data-panel])').forEach((a) => a.addEventListener('mouseenter', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  addEventListener('scroll', close, { passive: true });
  document.addEventListener('click', (e) => { if (cur && !e.target.closest('.sd-npanel') && !e.target.closest('a[data-panel]')) close(); });
}

const festGreet = document.querySelector('.sd-festg[data-fest-on]');
if (festGreet) {
  const html = document.documentElement;
  const fit = () => {
    festGreet.classList.remove('sd-cut');
    /* Exact widths: scrollWidth rounds, so a word cut by 1px could still pass. */
    const r = document.createRange();
    r.selectNodeContents(festGreet);
    /* Once the page has said it (a filled greeting slot in <main>), the header stays quiet. */
    const said = !html.hasAttribute('data-festg') && document.querySelector('main [data-fest-slot="greeting"][data-fest-on]');
    const cut = !!said || r.getBoundingClientRect().width > festGreet.getBoundingClientRect().width + 0.1;
    festGreet.classList.toggle('sd-cut', cut);
    if (cut && html.hasAttribute('data-festg')) {
      html.removeAttribute('data-festg');
      window.SundayFest?.fill(document);
    }
    /* 22 Oct (AR): the greeting now fits beside the logo (fonts loaded, wider screen): say it there, once.
       The home hero's top line goes back to its own words. */
    if (!cut && !html.hasAttribute('data-festg')) {
      html.setAttribute('data-festg', '');
      document.querySelectorAll('main .sd-dh-eb[data-fest-on][data-fest-orig]').forEach((el) => {
        el.textContent = el.getAttribute('data-fest-orig');
        el.removeAttribute('data-fest-on');
      });
    }
  };
  fit();
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(festGreet.parentElement);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  addEventListener('load', fit);
}

/* ---------- phone bars step aside while scrolling down (below 600 px) ---------- */
{
  const html = document.documentElement;
  const phone = matchMedia('(max-width: 599px)');
  let last = scrollY;
  const show = () => html.classList.remove('sd-hdhide', 'sd-dkhide');
  const busy = () => html.classList.contains('sd-hc-open') || !!document.querySelector('.sd-ov:not([hidden])') || !!document.activeElement?.matches?.('input, textarea, select');
  addEventListener(
    'scroll',
    () => {
      if (!phone.matches || busy()) return show();
      /* 26 Oct (AR): opened from another mattress's tile, the bar holds the state it had there while the page lands */
      if (html.classList.contains('sd-hdhold')) { last = scrollY; return; }
      const y = scrollY;
      const d = y - last;
      const end = y + innerHeight >= document.documentElement.scrollHeight - 40;
      if (y < 80 || end) show();
      /* 26 Oct (AR go: the bar's Help me choose kept sliding away and back, a flicker): the bottom bar stays put;
         only the slim header steps aside while scrolling down */
      else if (d > 6) html.classList.add('sd-hdhide');
      else if (d < -6) show();
      if (Math.abs(d) > 6) last = y;
    },
    { passive: true }
  );
  phone.addEventListener('change', show);
}

/* Order journey (AR, 17 Oct): each page's short name (header data-sd-step, English) and language
   (data-sd-lang) are kept in this browser only, in localStorage['sunday-journey']; the cart page saves the
   line on the cart, so the team sees it on the order (Additional details → Journey). A reload of the same
   page within 30 minutes is not a new step. After an order a new cart starts the next line from the pages seen after that order. */
(() => {
  const h = document.querySelector('[data-sd-step]');
  if (!h || !h.dataset.sdStep) return;
  const KEY = 'sunday-journey';
  const tok = decodeURIComponent((document.cookie.match(/(?:^|; )cart=([^;]*)/) || [])[1] || '').split('?')[0];
  try {
    let j = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!j || !Array.isArray(j.s)) j = { s: [] };
    /* a new cart after a saved one: the pages up to that save belonged to the last order */
    if (j.sent && tok && j.sent !== tok) j = { s: j.s.filter((x) => x.t > (j.at || 0)) };
    const now = Date.now();
    const last = j.s[j.s.length - 1];
    if (last && last.p === h.dataset.sdStep && last.l === h.dataset.sdLang && now - last.t < 18e5) last.t = now;
    else j.s.push({ p: h.dataset.sdStep, l: h.dataset.sdLang, c: document.documentElement.lang, t: now });
    j.s = j.s.slice(-80);
    localStorage.setItem(KEY, JSON.stringify(j));
  } catch (e) {
    /* storage blocked: no journey line */
  }
})();

/* Indian-script pages keep the English line count where English has one line (AR, 17 Oct):
   - a headline printed sentence by sentence (span.sd-nb, snippets/sunday-sentences) keeps each sentence on one line;
   - one-line words (product name, the cart's Checkout, compare-table feel, Remove, Mattresses card names on a phone, the
     sticky bar's size, the home rating line, home tile names from 960 px) stay on one line.
   When the words are wider than their box, their type steps down just enough (never below 70% for a headline,
   80% for the rest; words that would still wrap at 80% keep their size and wrap as before). Runs when fonts load, on resize and when the
   festival engine fills the headline. English pages are left alone. */
if (!/^en/.test(document.documentElement.lang)) {
  const ONE = ['.sd-mh-h1', '.sd-cpay > span', '.sd-bct-fe > b', '.sd-row > .sd-lnk', '.sd-mbar-chip > span', '.sd-dh-rate > em', '.sd-mbar-add', '.sd-mh-fm', '.sd-ttp', '.sd-apbar-p', '.sd-a2bar-t', '.sd-mfl-cue'];
  const ONE_PHONE = ['.sd-mx-chip > b', '.sd-mx-band > small', '.sd-mx-fm > span', '.sd-mx-pr > .sd-num']; /* Mattresses phone bar names; card tag, feel and From price (24 Oct) */
  const ONE_WIDE = ['.sd-mtile h3'];
  /* the room for the words inside the element (padding left out) */
  const room = (el) => {
    const cs = getComputedStyle(el);
    const pad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    return (el.clientWidth || el.getBoundingClientRect().width) - (el.clientWidth ? pad : 0);
  };
  /* the new size, or null to leave it: words that would still wrap at the smallest size keep their size and wrap */
  const shrunk = (fs, box, need, min, all) => {
    if (!box || need <= box + 0.5) return null;
    if (!all && (box - 1) / need < min) return null;
    return Math.max(fs * min, Math.floor((fs * (box - 1)) / need * 10) / 10);
  };
  const width = (el) => {
    const g = document.createRange();
    g.selectNodeContents(el);
    return g.getBoundingClientRect().width;
  };
  /* 25 Oct (speed): every element is measured in two passes (all on one line, then as laid out), and the sizes are
     written at the end, so a pass lays the page out about three times instead of three times per element. */
  const allSel = ONE.concat(ONE_PHONE, ONE_WIDE).join(', ');
  /* only: the elements to fit (a Set), or every one on the page */
  const fitNb = (only = null) => {
    const mine = (el) => !only || only.has(el);
    /* 21 Oct (older phones): no :has() in a selector (it throws on Chrome < 105 and stops this script) */
    const heads = [...document.querySelectorAll('h1, h2')].filter((x) => mine(x) && x.querySelector(':scope > .sd-nb'));
    const parts = heads.map((h) => [...h.querySelectorAll(':scope > .sd-nb')]);
    const sel = ONE.concat(innerWidth < 720 ? ONE_PHONE : [], innerWidth >= 960 ? ONE_WIDE : []).join(', ');
    const phoneSel = ONE_PHONE.join(', ');
    /* writes: back to the stylesheet's size */
    heads.forEach((h) => h.style.removeProperty('font-size'));
    (only ? [...only].filter((el) => el.matches(allSel)) : document.querySelectorAll(allSel)).forEach((el) => el.style.removeProperty('font-size'));
    const els = [...document.querySelectorAll(sel)].filter((el) => mine(el) && el.getClientRects().length);
    /* pass 1: everything on one line, measured */
    const nowrap = parts.flat().concat(els);
    nowrap.forEach((el) => el.style.setProperty('white-space', 'nowrap', 'important'));
    const widest = parts.map((ss) => ss.reduce((m, sp) => Math.max(m, sp.getBoundingClientRect().width), 0));
    const need = els.map(width);
    nowrap.forEach((el) => el.style.removeProperty('white-space'));
    /* pass 2: as laid out */
    const hNow = heads.map((h) => [h.clientWidth, parseFloat(getComputedStyle(h).fontSize)]);
    const eNow = els.map((el) => [room(el), parseFloat(getComputedStyle(el).fontSize)]);
    /* writes */
    heads.forEach((h, i) => {
      if (h.matches(allSel)) return; /* a heading that is also a one-line word follows the one-line rule (as before) */
      const px = shrunk(hNow[i][1], hNow[i][0], widest[i], 0.7, true);
      if (px != null) h.style.setProperty('font-size', px + 'px');
    });
    els.forEach((el, i) => {
      /* the three narrow cards on a phone may step down to 75% (24 Oct: Malayalam feel line needed 78%) */
      const px = shrunk(eNow[i][1], eNow[i][0], need[i], innerWidth < 720 && el.matches(phoneSel) ? 0.75 : 0.8, false);
      if (px != null) el.style.setProperty('font-size', px + 'px');
    });
  };
  let fitT;
  const fitSoon = () => { clearTimeout(fitT); fitT = setTimeout(() => fitNb(), 150); };
  fitNb();
  /* 25 Oct (speed): again when the fonts arrive, only if they were still on their way (it used to run twice in a row) */
  if (document.fonts && document.fonts.status !== 'loaded') document.fonts.ready.then(() => fitNb());
  addEventListener('resize', fitSoon, { passive: true });
  /* parts drawn or refilled later by their own scripts (festival headline, sticky bar, topper, cart).
     25 Oct (speed): only the fitted words that changed are fitted again; any other change on the page is left alone
     (a size tap used to refit the whole page). */
  const watch = allSel + ', h1, h2';
  let todo = new Set();
  let todoT;
  new MutationObserver((ms) => {
    for (const m of ms) {
      const t = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      const hit = t && t.closest(watch);
      if (hit) todo.add(hit);
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches(watch)) todo.add(n);
        n.querySelectorAll(watch).forEach((x) => todo.add(x));
      }
    }
    if (!todo.size) return;
    clearTimeout(todoT);
    todoT = setTimeout(() => {
      const only = todo;
      todo = new Set();
      fitNb(only);
    }, 150);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
}

/* Language pages: links typed as "/pages/…" in settings get the language in front ("/hi/pages/…"), so a visitor stays in their language. */
{
  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  if (root) {
    const skip = /^\/(cdn|apps|checkout|account|services|tools)\b/;
    const fix = (a) => {
      const h = a.getAttribute('href');
      if (!h || h[0] !== '/' || h[1] === '/' || h === root || h.startsWith(root + '/') || h.startsWith(root + '?') || h.startsWith(root + '#') || skip.test(h)) return;
      a.setAttribute('href', root + h);
    };
    const all = (n) => n.querySelectorAll?.('a[href^="/"]').forEach(fix);
    all(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) { if (n.matches('a[href^="/"]')) fix(n); all(n); } }))).observe(document.body, { childList: true, subtree: true });
  }
}

/* 25 Oct (speed): Shopify refuses early page loads, so once this page has loaded, fetch the mattress page's and the
   cart page's own files into the cache (list printed by sections/sunday-header.liquid). Already cached: no download. */
/* 26 Oct (AR go, network): handed to the browser as prefetch (lowest priority, only when idle, never competing with
   the page), files this page already loaded are skipped, and nothing is warmed on a slow or data-saver connection. */
{
  const list = document.querySelector('[data-sunday-header]')?.dataset.sdWarm;
  const c = navigator.connection;
  const slow = !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  const bare = (u) => u.split('?')[0].replace(/^https?:/, '');
  const go = () => (window.requestIdleCallback || setTimeout)(() => {
    const have = new Set(performance.getEntriesByType('resource').map((e) => bare(e.name)));
    for (const u of list.split(/\s+/)) {
      if (!u || have.has(bare(u))) continue;
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = u;
      document.head.append(l);
    }
  });
  if (list && !slow) document.readyState === 'complete' ? go() : addEventListener('load', go, { once: true });
}

/* 26 Oct (AR + Jobs, desktop from 1100): the short line under the header number has a green dot and "until 7 pm"
   while the store is open, a grey dot and the hours ("10 am – 7 pm") when closed,
   from the store hours in India time (first two times in the text, any language; without am/pm a closing hour at or
   before the opening hour is in the afternoon). Once a visit, in office hours, 3 s after the page loads, the glass
   label under the number shows for 6 s and the promise line under the header fades while it does. */
{
  const a = document.querySelector('.sd-hphone[data-hours], .sd-hphone[data-always]');
  const always = !!(a && a.hasAttribute('data-always')); /* 4 Nov (AR): calls answered 24/7 */
  const t = [];
  if (always) t.push({ min: 0, label: '' }, { min: 1440, label: '' });
  else if (a) {
    const re = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/gi;
    let m;
    while ((m = re.exec(a.dataset.hours)) && t.length < 2) t.push({ min: (Number(m[1]) % 12 + (/pm/i.test(m[3] || '') ? 12 : 0)) * 60 + Number(m[2] || 0), ap: !!m[3], label: m[1] + (m[2] ? ':' + m[2] : '') + (m[3] ? ' ' + m[3].toLowerCase() : '') });
    if (t.length === 2 && !t[1].ap && t[1].min <= t[0].min) t[1].min += 720;
  }
  if (t.length === 2) {
    const open = () => {
      const d = new Date();
      const ist = (d.getUTCHours() * 60 + d.getUTCMinutes() + 330) % 1440;
      return ist >= t[0].min && ist < t[1].min;
    };
    const hpt = a.querySelector('[data-sd-hpt]');
    const paint = () => {
      const o = open();
      a.classList.toggle('is-open', o);
      a.classList.toggle('is-closed', !o);
      if (hpt) {
        const w = always ? a.dataset.always : o ? (a.dataset.open || '').replace('[close]', t[1].label) : t[0].label + ' – ' + t[1].label;
        if (hpt.textContent !== w) hpt.textContent = w;
      }
      return o;
    };
    paint();
    setInterval(paint, 60000);
    const lab = a.querySelector('[data-sd-hpl]');
    const KEY = 'sunday-hpl';
    let seen = true;
    try {
      seen = !!sessionStorage.getItem(KEY);
    } catch {}
    if (lab && !seen && matchMedia('(min-width: 1100px)').matches) {
      setTimeout(() => {
        const r = a.getBoundingClientRect();
        const html = document.documentElement;
        if (!paint() || !r.width || r.top < 0 || [...document.querySelectorAll('[aria-modal="true"], dialog[open]')].some((d) => d.getClientRects().length) || html.classList.contains('sd-hc-open')) return;
        try {
          sessionStorage.setItem(KEY, '1');
        } catch {}
        lab.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => html.classList.add('sd-hpl-on')));
        setTimeout(() => {
          html.classList.remove('sd-hpl-on');
          setTimeout(() => (lab.hidden = true), 450);
        }, 6000);
      }, 3000);
    }
  }
}

/* 26 Oct (AR): the in/cm choice made on a mattress page carries to every page. With cm chosen
   (localStorage['sunday-unit']), every size written length × width in inches ("78×60″") reads in cm ("198×152 cm"),
   including sizes scripts draw later. The mattress pages draw their own sizes in the unit chosen. */
(() => {
  let cmOn = false;
  try { cmOn = localStorage.getItem('sunday-unit') === 'cm'; } catch (e) {}
  if (!cmOn) return;
  const RX = /(\d{2,3})\s?[×x]\s?(\d{2,3})\s?(?:″|"|”|in\b)/g;
  const RT = new RegExp(RX.source);
  const to = (n) => Math.round(Number(n) * 2.54);
  const skip = (el) => !el || el.closest('script,style,textarea,input,sunday-m-hero [data-sizes],sunday-m-hero [data-sizes-sheet],sunday-m-hero [data-measure],[contenteditable]');
  const fix = (root) => {
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (RT.test(n.nodeValue) && !skip(n.parentElement) ? 1 : 2) });
    const list = [];
    for (let n = w.nextNode(); n; n = w.nextNode()) list.push(n);
    list.forEach((n) => { RX.lastIndex = 0; n.nodeValue = n.nodeValue.replace(RX, (m, a, b) => `${to(a)}×${to(b)} cm`); });
    RX.lastIndex = 0;
  };
  const go = () => {
    const main = document.querySelector('main') || document.body;
    fix(main);
    let t = 0;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => fix(main), 30); }).observe(main, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();

/* 26 Oct (AR): no sound on any product page. Every video there stays muted, even if its controls are used
   (the header carries data-sd-mute on product pages only). */
if (document.querySelector('[data-sunday-header][data-sd-mute]')) {
  const hush = (e) => { const v = e.target; if (v instanceof HTMLMediaElement && !v.muted) v.muted = true; };
  document.addEventListener('volumechange', hush, true);
  document.addEventListener('play', hush, true);
}
